const Information = () => <>회원안내</>;

export default Information;
